import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const FlagFill = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='FlagFill' {...props}>
    <path fillRule='evenodd' stroke='#000' strokeWidth='2' d='M2,24 L2,2 C10,-1.5238864 13,6.64375708 22,2 L22,14 C14,18.895222 9,9.89651097 2,14' />
  </StyledIcon>
);
